__turbopack_context__.v({
  "acceligent": "qD-eua_acceligent",
  "audubon": "qD-eua_audubon",
  "content": "qD-eua_content",
  "credit": "qD-eua_credit",
  "highlight-enter-acceligent": "qD-eua_highlight-enter-acceligent",
  "highlight-enter-squadlocker": "qD-eua_highlight-enter-squadlocker",
  "highlight-leave-acceligent": "qD-eua_highlight-leave-acceligent",
  "highlight-leave-squadlocker": "qD-eua_highlight-leave-squadlocker",
  "in-view": "qD-eua_in-view",
  "pista": "qD-eua_pista",
  "pixels": "qD-eua_pixels",
  "portrait": "qD-eua_portrait",
  "quote": "qD-eua_quote",
  "results": "qD-eua_results",
  "social-proof": "qD-eua_social-proof",
  "squadlocker": "qD-eua_squadlocker",
  "text": "qD-eua_text",
  "title": "qD-eua_title",
});
